import { FC, Fragment } from 'react';

import { Icon } from 'icons';
import { Stack } from 'modules/common/components/Stack/Stack';
import { useAppSelector } from 'modules/common/hooks/redux';
import { CommentItem } from './CommentItem';
import {
  commentsIsFetchingSelector,
  selectAll,
} from 'redux/reducers/comments/selectors';

interface BookCommentsProps {
  onDelete: (commentId: string, chapterId: string) => void;
  onEdit: (id: string, commentId: string, comment: string) => void;
  onClick: (commentId: string) => void;
}

export const BookComments: FC<BookCommentsProps> = ({
  onDelete,
  onEdit,
  onClick,
}) => {
  const comments = useAppSelector(selectAll);
  const isCommentFetching = useAppSelector(commentsIsFetchingSelector);

  return (
    <Fragment>
      {!isCommentFetching && !comments.length && (
        <Stack className="h-100" alignItems="center" justifyContent="center">
          <Stack.Item shrink={0}>
            <div className="ta-center">
              <Icon name="comment" size={40} className="opacity-30" />
              <p className="m-t-2 fw-600 font-size-sm opacity-50">
                List of Comments is empty
              </p>
            </div>
          </Stack.Item>
        </Stack>
      )}
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          onDelete={onDelete}
          onEdit={onEdit}
          onClick={onClick}
        />
      ))}
    </Fragment>
  );
};
